import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-agree-kursk',
  templateUrl: './agree-kursk.component.html',
  styleUrls: ['./agree-kursk.component.scss']
})
export class AgreeKurskComponent implements OnInit {

  constructor(
    private viewportScroller: ViewportScroller,
  ) { }

  ngOnInit(): void {
    this.toTop();
  }
  toTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
